
/** 
 * Gets a local file, using fetch. Adapted from fetch drivers from other projects
 */
export const getLocalFile = (url) => {
    return fetch(url, {
            method: 'GET',
            credentials: 'same-origin'
        }).then(response => {
            const contentType = response.headers.get('content-type');
            if (contentType.indexOf('json') > -1) {
                return response.json();
            } else {
                return response.text();
            }
        }).catch(error => {
            const contentType = error.headers.get('content-type');
            if (contentType.indexOf('json') > -1) {
                return error.json().then(err => ({
                    status: 'error',
                    code: error.status,
                    message: err.message || 'An error occurred',
                }));
            } else {
                return error
                    .text()
                    .then(err => ({ status: 'error', code: error.status, message: err }));
            }
        });
};